import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { useGet, useSet, useLastResolved } from 'ccstate-react';
import { fileExplorerState } from '../state/fileExplorerState';
import { navigateToFolder$, setViewMode$, setSearchQuery$, createFolder$, uploadFile$ } from '../commands/fileCommands';
export default function TopNavigation() {
    // const currentFolderId = useGet(fileExplorerState.currentFolderId$) // May be used later
    const viewMode = useGet(fileExplorerState.viewMode$);
    const searchQuery = useGet(fileExplorerState.searchQuery$);
    const breadcrumbPath = useLastResolved(fileExplorerState.breadcrumbPath$) || [];
    const navigateToFolder = useSet(navigateToFolder$);
    const setViewMode = useSet(setViewMode$);
    const setSearchQuery = useSet(setSearchQuery$);
    const createFolder = useSet(createFolder$);
    const uploadFile = useSet(uploadFile$);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [newFolderName, setNewFolderName] = useState('');
    const handleCreateFolder = async () => {
        if (newFolderName.trim()) {
            try {
                await createFolder(newFolderName.trim());
                setShowCreateModal(false);
                setNewFolderName('');
            }
            catch (error) {
                console.error('Failed to create folder:', error);
            }
        }
    };
    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            const file = files[0];
            const reader = new FileReader();
            reader.onload = async () => {
                try {
                    await uploadFile({
                        name: file.name,
                        type: file.type,
                        size: file.size,
                        content: reader.result as string
                    });
                }
                catch (error) {
                    console.error('Failed to upload file:', error);
                }
            };
            reader.readAsDataURL(file);
        }
        // Reset input
        event.target.value = '';
    };
    return (<div className="w-full bg-white border-b border-[#E0E7EF]" data-id="vb97gt">
      <div className="flex items-center gap-6 px-6 py-3" data-id="l0ljxz">
        {/* Logo/Brand */}
        <div className="flex items-center gap-2 flex-shrink-0" data-id="ka8y73">
          <Icon icon="lucide:folder-open" className="w-6 h-6 text-[#4A90E2]" data-id="vy80nt"/>
          <span className="text-lg font-semibold text-[#1A2B3D]" data-id="5bf2gw">File Explorer</span>
        </div>

        {/* Breadcrumb Navigation */}
        <div className="flex items-center gap-2 flex-1 min-w-0" data-testid="breadcrumb-navigation" data-id="c719f2">
          {(breadcrumbPath as any[]).map((item: any, index: number) => (<React.Fragment key={item.id}>
              {index > 0 && (<Icon icon="lucide:chevron-right" className="w-3 h-3 text-[#B8C1CC] flex-shrink-0" data-id="5bk4hg"/>)}
              <button onClick={() => navigateToFolder(item.id === 'root' ? 'root' : item.id)} className="text-sm text-[#5A6C7D] hover:text-[#4A90E2] truncate" data-testid={`breadcrumb-${item.id}`} data-id="blvqyy">
                {item.name}
              </button>
            </React.Fragment>))}
        </div>

        {/* Search Bar */}
        <div className="relative flex-shrink-0" data-id="mlc228">
          <Icon icon="lucide:search" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-[#B8C1CC]" data-id="xxgjod"/>
          <input type="text" placeholder="Search files and folders..." value={searchQuery as string} onChange={(e) => setSearchQuery(e.target.value)} className="pl-10 pr-4 py-2 w-64 bg-white border border-[#E0E7EF] rounded-md text-[#1A2B3D] placeholder:text-[#B8C1CC] focus:border-[#4A90E2] focus:outline-none" data-testid="search-input" data-id="nvjwud"/>
        </div>

        {/* View Toggle */}
        <div className="flex items-center bg-[#F7F9FC] rounded-md p-1 flex-shrink-0" data-id="0ttksd">
          <button onClick={() => setViewMode('grid')} className={`flex items-center justify-center w-8 h-8 rounded ${viewMode === 'grid' ? 'bg-white shadow-[0_1px_3px_rgba(26,43,61,0.08)]' : 'hover:bg-white/50'}`} data-testid="view-grid-button" data-id="edwv4h">
            <Icon icon="lucide:grid-3x3" className="w-4 h-4 text-[#5A6C7D]" data-id="ecgpiw"/>
          </button>
          <button onClick={() => setViewMode('list')} className={`flex items-center justify-center w-8 h-8 rounded ${viewMode === 'list' ? 'bg-white shadow-[0_1px_3px_rgba(26,43,61,0.08)]' : 'hover:bg-white/50'}`} data-testid="view-list-button" data-id="x891pd">
            <Icon icon="lucide:list" className="w-4 h-4 text-[#5A6C7D]" data-id="igbegv"/>
          </button>
        </div>

        {/* Upload Button */}
        <div className="relative flex-shrink-0" data-id="puexpu">
          <input type="file" id="file-upload" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={handleFileUpload} data-testid="upload-input" data-id="1d3iq6"/>
          <label htmlFor="file-upload" className="flex items-center gap-2 px-4 py-2 bg-[#4A90E2] text-white rounded-md hover:bg-[#3A7AC8] cursor-pointer" data-id="griku4">
            <Icon icon="lucide:upload" className="w-4 h-4" data-id="sv2xlh"/>
            <span data-id="n43hux">Upload</span>
          </label>
        </div>

        {/* New Folder Button */}
        <button onClick={() => setShowCreateModal(true)} className="flex items-center gap-2 px-4 py-2 bg-transparent text-[#4A90E2] border border-[#4A90E2] rounded-md hover:bg-[#E8F2FC] flex-shrink-0" data-testid="new-folder-button" data-id="bxonsc">
          <Icon icon="lucide:folder-plus" className="w-4 h-4" data-id="o5u2px"/>
          <span data-id="sbqeas">New Folder</span>
        </button>
      </div>

      {/* Create Folder Modal */}
      {showCreateModal && (<div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowCreateModal(false)} data-id="feewi5">
          <div className="bg-white rounded-lg p-6 w-96 shadow-[0_8px_24px_rgba(26,43,61,0.16)]" onClick={(e) => e.stopPropagation()} data-id="imyqtj">
            <h3 className="text-lg font-semibold text-[#1A2B3D] mb-4" data-id="vl1hpl">Create New Folder</h3>
            <input type="text" placeholder="Folder name" value={newFolderName} onChange={(e) => setNewFolderName(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleCreateFolder()} className="w-full px-3 py-2 bg-white border border-[#E0E7EF] rounded-md text-[#1A2B3D] placeholder:text-[#B8C1CC] focus:border-[#4A90E2] focus:outline-none mb-4" autoFocus data-testid="folder-name-input" data-id="zmgbt3"/>
            <div className="flex gap-2 justify-end" data-id="7mgyla">
              <button onClick={() => setShowCreateModal(false)} className="px-4 py-2 text-[#5A6C7D] hover:bg-[#F0F4F8] rounded-md" data-id="k1vn2p">
                Cancel
              </button>
              <button onClick={handleCreateFolder} className="px-4 py-2 bg-[#4A90E2] text-white rounded-md hover:bg-[#3A7AC8]" data-testid="create-folder-confirm" data-id="8guoeg">
                Create
              </button>
            </div>
          </div>
        </div>)}
    </div>);
}
